/**
 * Reads annotation information from the active annotations service and extracts the SVG data.
 * @param serviceLocator (object) The service locator, injected from the Annotations extension
 */
export const createHelper = (serviceLocator) => {
  return {
    getSvgData (viewport, rectangle, captureZoom) {
      // Extract annotations as blob
      const svg = serviceLocator.annotationsService.paper.canvas;
      const $svg = $(svg);
      let content = new XMLSerializer().serializeToString(svg);

      // Explicitly set the height and width; otherwise the 100% rules will constrain the SVG to the canvas's height/width
      // and the svg overlay will only be visible at the image origin!
      const meta = {
        x: rectangle.x,
        y: rectangle.y,
        h: $svg.height(),
        w: $svg.width(),
        scale: viewport.getVPView().zoom / captureZoom
      };
      content = content.replace('height="100%"', `height="${meta.h}"`);
      content = content.replace('width="100%"', `width="${meta.w}" `);

      // The XML Serializer appears to add an extra xmlns attribute in IE, which prevents the image from
      // rendering. If we just blindly remove the attribute then Chrome/FF fail to render. So we check to see if
      // there's more than one and remove the first. Note that if we were to somehow end up with more than 2
      // the following logic would need to change, but YAGNI.
      if (content.match(/xmlns=/g).length > 1) {
        content = content.replace('xmlns="http://www.w3.org/2000/svg"', '');
      }

      return {
        content,
        meta
      };
    }
  };
};
